import { defineStore } from 'pinia'
import { ref } from 'vue'
import { IRecommendedPrice } from '@/apps/traforama/interfaces/recomendedPrices'
import { fetchItems } from '@/apps/traforama/api/recomendedPrices'

export const useRecommendedPricesStore = defineStore(
  'recommendedPrices',
  () => {
    const items = ref<{ [itemId: string]: IRecommendedPrice }>({})

    const FetchItems = async (campaignId: number) => {
      const response = await fetchItems(campaignId)
      setItems(response.data)
    }

    const setItems = (newItems: Array<IRecommendedPrice>) => {
      newItems.forEach((item) => {
        items.value[item.country_id] = item
      })
    }

    return {
      items,
      FetchItems
    }
  }
)
